/**
 * StepProgressBar — 출제 과정의 현재 단계를 표시. (ECHO 톤)
 * 완료 단계는 클릭해서 되돌아갈 수 있습니다.
 */
const StepProgressBar = ({ steps, currentStep, onStepClick }) => {
  const currentIndex = steps.findIndex((s) => s.key === currentStep);

  return (
    <div
      style={{
        padding: "14px 20px 10px",
        backgroundColor: "#FFF",
        borderBottom: "1px solid #ECF1F2",
        flexShrink: 0,
      }}
    >
      {/* 게이지 */}
      <div style={{ display: "flex", gap: "5px", marginBottom: "9px" }}>
        {steps.map((_, i) => (
          <div
            key={i}
            style={{
              flex: 1,
              height: "4px",
              borderRadius: "3px",
              backgroundColor:
                i < currentIndex
                  ? "#00D9C0"
                  : i === currentIndex
                  ? "#0E141B"
                  : "#E6EDEC",
              transition: "background-color .25s",
            }}
          />
        ))}
      </div>

      {/* 단계 라벨 */}
      <div
        style={{
          display: "flex",
          gap: "2px",
          overflowX: "auto",
          WebkitOverflowScrolling: "touch",
        }}
      >
        {steps.map((step, i) => {
          const isDone = i < currentIndex;
          const isCurrent = i === currentIndex;
          return (
            <button
              key={step.key}
              onClick={() => isDone && onStepClick?.(step.key)}
              disabled={!isDone}
              style={{
                flex: 1,
                minWidth: 0,
                padding: "4px 2px",
                textAlign: "center",
                fontSize: "0.74rem",
                fontWeight: isCurrent ? 800 : 600,
                letterSpacing: "-0.01em",
                color: isCurrent ? "#0E141B" : isDone ? "#00A396" : "#B9C1C9",
                border: "none",
                background: "none",
                fontFamily: "inherit",
                whiteSpace: "nowrap",
                cursor: isDone ? "pointer" : "default",
              }}
            >
              {i + 1}. {step.label}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default StepProgressBar;
